module.exports = __webpack_public_path__ + "static/media/jrunning.882f3bb1.jpg";